// even0Coffee Pre-Order Progress Bar
// Uses Shopify metafield data (no external API). Disables Add to Cart when goal met.
// Re-fetches the section HTML so totals update after checkout / webhook (avoids stale Liquid in the tab).

function checkPreOrderStatusAndDisableButton(vendorName, totalSales, targetSales) {
  const goalMet = totalSales >= targetSales;
  if (!goalMet) return;

  const submitButton = document.querySelector(`button[data-vendor="${vendorName}"]`);
  if (!submitButton) return;

  const productGoal = parseFloat(submitButton.getAttribute('data-goal')) || targetSales;
  if (totalSales < productGoal) return;

  submitButton.disabled = true;
  submitButton.style.backgroundColor = '#E0E0E0';
  submitButton.style.cursor = 'not-allowed';

  const buttonContainer = submitButton.closest('.product-form__buttons');
  if (buttonContainer && !buttonContainer.querySelector('.preorder-goal-met')) {
    const closedNotice = document.createElement('div');
    closedNotice.className = 'preorder-goal-met';
    closedNotice.innerHTML = `
      <p>
        🎉 Pre-order goal achieved! This pre-order window is now closed. Thank you for your support!
      </p>
    `;
    submitButton.style.display = 'none';
    buttonContainer.appendChild(closedNotice);
  }
}

function initProgressBars() {
  const vendorElements = document.querySelectorAll('.vendor-progress');
  vendorElements.forEach((vendorElement) => {
    const vendorName = vendorElement.getAttribute('data-vendor');
    const targetSales = parseFloat(vendorElement.getAttribute('data-target')) || 50000;
    const currentSales = parseFloat(vendorElement.getAttribute('data-current-sales')) || 0;

    checkPreOrderStatusAndDisableButton(vendorName, currentSales, targetSales);
  });
}

function getVendorProgressSectionWrapper() {
  const inner = document.getElementById('vendor-progress-container');
  if (!inner) return null;
  return inner.closest('[id^="shopify-section-"]');
}

let lastVendorProgressFetchAt = 0;
let vendorProgressRefreshTimer = null;
let vendorProgressFetchInFlight = false;

const VENDOR_PROGRESS_MIN_INTERVAL_MS = 10000;
const VENDOR_PROGRESS_POST_LOAD_MS = 4000;
const VENDOR_PROGRESS_VISIBILITY_DEBOUNCE_MS = 600;

function isShopifyDesignMode() {
  return document.documentElement.classList.contains('shopify-design-mode');
}

function refreshVendorProgressBarFromServer(force) {
  if (isShopifyDesignMode()) return;
  if (vendorProgressFetchInFlight) return;

  const wrapper = getVendorProgressSectionWrapper();
  if (!wrapper || !wrapper.id.startsWith('shopify-section-')) return;

  const now = Date.now();
  if (!force && now - lastVendorProgressFetchAt < VENDOR_PROGRESS_MIN_INTERVAL_MS) return;

  const sectionId = wrapper.id.slice('shopify-section-'.length);
  const url = new URL(window.location.href);
  url.searchParams.set('sections', sectionId);
  url.searchParams.set('_vb', String(now));

  vendorProgressFetchInFlight = true;
  lastVendorProgressFetchAt = now;

  fetch(url.toString(), { credentials: 'same-origin' })
    .then((res) => {
      if (!res.ok) throw new Error(`Section fetch ${res.status}`);
      return res.json();
    })
    .then((data) => {
      const html = data[sectionId];
      if (html == null || typeof html !== 'string') return;

      const tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      const newSection = tmp.firstElementChild;
      if (!newSection || !newSection.id) return;

      const live = getVendorProgressSectionWrapper();
      if (live) live.replaceWith(newSection);
      initProgressBars();
    })
    .catch(() => {
      /* network / parse; keep existing bar */
    })
    .finally(() => {
      vendorProgressFetchInFlight = false;
    });
}

function scheduleVendorProgressRefresh(force) {
  if (vendorProgressRefreshTimer) clearTimeout(vendorProgressRefreshTimer);
  vendorProgressRefreshTimer = setTimeout(() => {
    vendorProgressRefreshTimer = null;
    void refreshVendorProgressBarFromServer(force);
  }, VENDOR_PROGRESS_VISIBILITY_DEBOUNCE_MS);
}

function setupVendorProgressBarLiveUpdates() {
  if (window.__vendorProgressBarLiveUpdates) return;
  if (isShopifyDesignMode()) return;
  if (!getVendorProgressSectionWrapper()) return;

  window.__vendorProgressBarLiveUpdates = true;

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    scheduleVendorProgressRefresh(false);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      void refreshVendorProgressBarFromServer(true);
    }
  });

  // After returning from checkout, metafields may update slightly after first paint; one delayed pull.
  setTimeout(() => void refreshVendorProgressBarFromServer(true), VENDOR_PROGRESS_POST_LOAD_MS);
}

document.addEventListener('DOMContentLoaded', () => {
  initProgressBars();
  setupVendorProgressBarLiveUpdates();
});
document.addEventListener('shopify:section:load', initProgressBars);
